'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Decorator


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _imageFileDropTargetDecorator = require('../../../../../../../components/tools/images/imageFileDropTargetDecorator');

var _imageFileDropTargetDecorator2 = _interopRequireDefault(_imageFileDropTargetDecorator);

var _ImageFileInput = require('../../../../../../../components/tools/images/ImageFileInput');

var _ImageFileInput2 = _interopRequireDefault(_ImageFileInput);

var _BoardImageUploadIcon = require('./BoardImageUploadIcon');

var _BoardImageUploadIcon2 = _interopRequireDefault(_BoardImageUploadIcon);

var _Overlay = require('../../../../../../../components/misc/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _BoardImage = require('../../../../../../../element/board/boardIcon/BoardImage');

var _BoardImage2 = _interopRequireDefault(_BoardImage);

require('./BoardImagePicker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoardImagePicker = (_dec = (0, _imageFileDropTargetDecorator2.default)(), _dec(_class = function (_React$Component) {
    _inherits(BoardImagePicker, _React$Component);

    function BoardImagePicker() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BoardImagePicker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoardImagePicker.__proto__ || Object.getPrototypeOf(BoardImagePicker)).call.apply(_ref, [this].concat(args))), _this), _this.openFileSelect = function (event) {
            var imageFileInput = _this.refs.imageFileInput;

            var fileInputDomNode = _reactDom2.default.findDOMNode(imageFileInput);
            fileInputDomNode.click();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Delegates the click event on the fake file upload input to the real, hidden one.
     */


    _createClass(BoardImagePicker, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                selectedImage = _props.selectedImage,
                selectedElements = _props.selectedElements,
                gridSize = _props.gridSize,
                uploadImage = _props.uploadImage,
                imageIsHovered = _props.imageIsHovered,
                imageConnectDropTarget = _props.imageConnectDropTarget;


            var firstSelectedElement = selectedElements.first();
            var overlayText = selectedImage ? 'Change' : 'Upload';
            var titleText = selectedImage ? 'Change image' : 'Choose an image';
            var icon = selectedImage ? _react2.default.createElement(
                'div',
                { className: 'board-image-wrapper' },
                _react2.default.createElement(_BoardImage2.default, { element: firstSelectedElement, size: 8, gridSize: gridSize })
            ) : _react2.default.createElement(_BoardImageUploadIcon2.default, null);

            return imageConnectDropTarget(_react2.default.createElement(
                'div',
                { className: 'BoardImagePicker', onClick: this.openFileSelect },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('overlay-parent', { hovered: imageIsHovered }) },
                    _react2.default.createElement(_ImageFileInput2.default, { ref: 'imageFileInput', id: 'board', uploadImage: uploadImage }),
                    icon,
                    _react2.default.createElement(
                        _Overlay2.default,
                        null,
                        overlayText
                    )
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'upload-title' },
                    titleText
                )
            ));
        }
    }]);

    return BoardImagePicker;
}(_react2.default.Component)) || _class);


BoardImagePicker.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    selectedElements: _propTypes2.default.object.isRequired,
    selectedImage: _propTypes2.default.string,
    dispatchBoardImage: _propTypes2.default.func,
    uploadImage: _propTypes2.default.func.isRequired,
    imageIsHovered: _propTypes2.default.bool,
    imageConnectDropTarget: _propTypes2.default.func
};

exports.default = BoardImagePicker;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/imagePicker/BoardImagePicker.js
// module id = 2243
// module chunks = 0